module.exports = __webpack_public_path__ + "img/VERIFIEDFORM.cf77ba31.png";